var React = require('react');
var ReactNative = require('react-native');

var JSQR = require('javascript-qrcode');

var {
  AppRegistry,
  View,
  InteractionManager,
  StyleSheet,
} = ReactNative;

// var RNQRCodeView = require('react-native-qrcode-view');

var QRCodeView = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      data : "",
      positiveColor : 'black',
      negativeColor : 'white',
      dimension : 200,
      spinnerView : <View />,
    }
  },

  getInitialState : function()
  {
    return {
      qrRendered : <View style={[styles.container,{margin:10,width:this.props.dimension,height:this.props.dimension, justifyContent:'center'}]} >{this.props.spinnerView}</View>,
    }
  },

  componentDidMount : function()
  {
    if( this.props.data.length > 0 )
    {
      this.setData(this.props.data);
    }
  },

  componentWillReceiveProps : function(newProps)
  {
    var shouldRerender = typeof newProps.dimension !== 'undefined' && newProps.dimension != this._dimension;
    if( typeof newProps.data !== 'undefined' && newProps.data.length > 0 && newProps.data != this._data )
    {
      this._data = newProps.data;
      shouldRerender = true;
    }
    if( shouldRerender )
    {
      this._dimension = newProps.dimension;
      var qrcode = new JSQR.QrCode(this._data);
      var matrix = qrcode.getData();
      var blockDim = Math.floor(newProps.dimension/matrix.length);
      var posCol = this.props.positiveColor;
      var negCol = this.props.negativeColor;
      var startIndex = -1;
      this.renderQRCode(matrix, blockDim, posCol, negCol, startIndex)
    }
  },

  _data : "",
  _hasRendered : false,
  _dimension : -1,
  setData : function(newData)
  {
    if( this._dimension < 0 ) this._dimension = this.props.dimension;
    if( newData == this._data ) return;

    this._data = newData;
    this.setState({qrRendered:<View style={[styles.container,{width:this._dimension,height:this._dimension, margin:10,padding:0, justifyContent:'center'}]} >{this.props.spinnerView}</View>});


    var thisThing = this;
    thisThing._hasRendered = false;
    InteractionManager.runAfterInteractions(() => {
      var qrcode = new JSQR.QrCode(thisThing._data);
      var matrix = qrcode.getData();
      var blockDim = Math.floor(thisThing._dimension/matrix.length);
      var posCol = thisThing.props.positiveColor;
      var negCol = thisThing.props.negativeColor;

      var startIndex = -1;
      thisThing.renderQRCode(matrix, blockDim, posCol, negCol, startIndex);
    });
    setTimeout(function()
    {
      if( !thisThing._hasRendered )
      {
        var qrcode = new JSQR.QrCode(thisThing._data);
        var matrix = qrcode.getData();
        var blockDim = Math.floor(thisThing._dimension/matrix.length);
        var posCol = thisThing.props.positiveColor;
        var negCol = thisThing.props.negativeColor;
        var startIndex = -1;
        thisThing.renderQRCode(matrix, blockDim, posCol, negCol, startIndex);
      }
    },400)
  },

  renderQRCode: function(matrix, blockDim, posCol, negCol, startIndex)
  {
    var thisThing = this;
    this._hasRendered = true;

    var blocksSize = matrix.length > 0 ? (matrix.length*blockDim) : 0;
    var blocks = [];
    for( var i = 0; i < matrix.length; i++ )
    {
      var row = matrix[i];
      var startIndex = -1;
      for( var j = 0; j < row.length; j++ )
      {
        var value = row[j];
        if( value == "1" )
        {
          if( startIndex < 0 )
          {
            startIndex = j;
          }
        }
        else if( value == "0" )
        {
          if( startIndex >= 0 )
          {
            blocks.push(<View style={{position:'absolute', top:i*blockDim, left:blockDim*startIndex, width:blockDim*(j-startIndex), height:blockDim, backgroundColor:posCol}} />);
            startIndex = -1;
          }
        }
      }
      if( startIndex >= 0 )
      {
        blocks.push(<View style={{position:'absolute', top:i*blockDim, left:blockDim*startIndex, width:blockDim*(j-startIndex), height:blockDim, backgroundColor:posCol}} />);
      }
    }

    var qrRendered = <View style={[styles.container, {backgroundColor:negCol, width:this._dimension + 20, height:this._dimension + 20, justifyContent:'center', alignItems:'center'}]}>
      <View style={{flex:-1, alignSelf:'center', width:blocksSize, height:blocksSize}}>
      {
        blocks
      }
      </View>
    </View>;

    thisThing.setState({qrRendered:qrRendered});
  },

  render: function()
  {
    return (
      <View ref='container' style={this.props.style}>
        {this.state.qrRendered}
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  row: {
    flexDirection: 'row',
  },
  block: {
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
});

module.exports = QRCodeView;



// WEBPACK FOOTER //
// ./src/QRCodeView.js